var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-6 tw-bg-gray-200 tw-p-4 tw-rounded-md"},[_vm._v("Resposta: "+_vm._s(_vm.answer))])}
var staticRenderFns = []

export { render, staticRenderFns }